module.exports = __webpack_public_path__ + "static/8_icerik_pazarlama-b13e028b544f02152879945794cabfea.webp";